<template>
  <div class="login" v-show="showLogin">
    <el-dialog
      :visible.sync="showLogin"
      :before-close="handleClose"
      width="60%"
      :lock-scroll="false"
      :show-close="false"
      :modal-append-to-body="false"
    >
      <div class="container" id="login-box">
        <div class="close" @click="handleClose"><i class="el-icon-close"></i></div>
        <div class="form-container sign-up-container">
          <el-form ref="regForm" :rules="rules" :model="regForm">
            <h1>注册</h1>
            <el-form-item class="txtb" prop="u_name">
              <input
                type="text"
                v-model.trim="regForm.u_name"
                @focus="inputFocus($event)"
                @blur="inputBlur($event)"
              />
              <span data-placeholder="用户名"></span>
            </el-form-item>
            <el-form-item class="txtb" prop="email">
              <input
                type="email"
                v-model.trim="regForm.email"
                @focus="inputFocus($event)"
                @blur="inputBlur($event)"
              />
              <span data-placeholder="Email"></span>
            </el-form-item>
            <el-form-item class="txtb" prop="password">
              <input
                type="password"
                v-model.trim="regForm.password"
                @focus="inputFocus($event)"
                @blur="inputBlur($event)"
              />
              <span data-placeholder="密码"></span>
            </el-form-item>
            <el-form-item class="txtb" prop="confirmPassword">
              <input
                type="password"
                v-model.trim="regForm.confirmPassword"
                @focus="inputFocus($event)"
                @blur="inputBlur($event)"
              />
              <span data-placeholder="确认密码"></span>
            </el-form-item>
            <el-button @click="regBtn">注册</el-button>
          </el-form>
        </div>
        <div class="form-container sign-in-container">
          <el-form ref="loginForm" :rules="rules" :model="loginForm">
            <h1>登录</h1>
            <el-form-item class="txtb" prop="email">
              <input
                type="email"
                ref="email"
                v-model.trim="loginForm.email"
                @focus="inputFocus($event)"
                @blur="inputBlur($event)"
              />
              <span data-placeholder="Email"></span>
            </el-form-item>
            <el-form-item class="txtb" prop="password">
              <input
                type="password"
                ref="password"
                v-model.trim="loginForm.password"
                @focus="inputFocus($event)"
                @blur="inputBlur($event)"
                @keydown.enter="loginBtn"
              />
              <span data-placeholder="密码"></span>
            </el-form-item>
            <el-row :gutter="10" class="code">
              <el-col :span="16">
                <el-form-item class="txtb" prop="code">
                  <input
                    v-model.trim="loginForm.code"
                    @focus="inputFocus($event)"
                    @blur="inputBlur($event)"
                    @keydown.enter="loginBtn"
                  />
                  <span data-placeholder="验证码"></span>
                </el-form-item>
              </el-col>
              <el-col :span="8" class="code-box">
                <VerifyCode
                  :identifyCode="identifyCode"
                  @refreshClick="refreshCode"
                ></VerifyCode>
              </el-col>
            </el-row>
            <!-- <a href="javaScript:;">忘记密码？</a> -->
            <el-button @click="loginBtn">登录</el-button>
          </el-form>
        </div>
        <div class="overlay-container">
          <div class="overlay">
            <div class="overlay-panel overlay-left">
              <h1>已有账号？</h1>
              <p>请使用您的账号进行登录</p>
              <button class="ghost" id="signIn" @click="signIn">登录</button>
            </div>
            <div class="overlay-panel overlay-right">
              <h1>没有账号?</h1>
              <p>立即注册加入享听大家庭吧</p>
              <button class="ghost" id="signUp" @click="signUp">注册</button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bus from "../eventBus";
import { validEmail } from "@/utils/validate";
import VerifyCode from "@/components/VerifyCode";
export default {
  components: {
    VerifyCode,
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入邮箱"));
      }
      if (!validEmail(value)) {
        callback(new Error("请输入正确邮箱"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value !== this.regForm.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      identifyCode: "",
      identifyCodes: "1234567890abcdefjhijklinopqrsduvwxyz",
      showLogin: false,
      loginForm: {
        email: "visitor@test.com",
        password: "123456",
        code: "",
      },
      regForm: {
        u_name: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
      rules: {
        u_name: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, max: 6, message: "长度在 3 到 6 个字符", trigger: "blur" },
        ],
        email: [
          { validator: validateEmail, trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        confirmPassword: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    showLogin: function (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.email.classList.add("focus");
          this.$refs.password.classList.add("focus");
        });
      }
    },
  },
  created() {
    bus.$on("show", (val, r) => {
      this.showLogin = val;
      this.$nextTick(() => {
        if (r == "right") {
          this.signUp();
        } else {
          this.signIn();
        }
      });
      document.body.style.overflow = "hidden";
    });
  },
  mounted() {
    this.refreshCode();
    // $("#signUp").click(function () {
    //   $("#login-box").addClass("right-panel-active");
    //   document.querySelector("#login-box").addClass("right-panel-active");
    // });
    // $("#signIn").click(function () {
    //   $("#login-box").removeClass("right-panel-active");
    // });
    // $(".txtb input").on("focus", function () {
    //   $(this).addClass("focus");
    // });
    // $(".txtb input").on("blur", function () {
    //   if ($(this).val() == "") $(this).removeClass("focus");
    // });
  },
  methods: {
    // 生成一个随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 生成一个随机数
    makeCode(length) {
      for (let i = 0; i < length; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
      }
    },
    // 重置验证码
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(4);
    },
    signIn() {
      document
        .querySelector("#login-box")
        .classList.remove("right-panel-active");
      this.$refs["loginForm"].resetFields();
    },
    signUp() {
      document.querySelector("#login-box").classList.add("right-panel-active");
      this.$refs["regForm"].resetFields();
    },
    inputFocus(el) {
      el.target.classList.add("focus");
    },
    inputBlur(el) {
      if (el.target.value == "") el.target.classList.remove("focus");
    },
    handleClose() {
      this.$refs["regForm"].resetFields();
      this.$refs["loginForm"].resetFields();
      document.querySelectorAll(".txtb input").forEach((item) => {
        item.classList.remove("focus");
      });
      document.body.style.overflow = "visible";
      this.showLogin = false;
    },
    loginBtn() {
      this.$refs["loginForm"].validate(async (valid) => {
        if (valid) {
          if (this.loginForm.code != this.identifyCode) {
            this.$message.warning("验证码错误");
            this.refreshCode();
            return;
          }
          const { data: res } = await this.$http.post("/login", this.loginForm);
          if (res.code !== 200) {
            this.refreshCode();
            return this.$message.error(res.message)
          };
          // 存储token
          window.sessionStorage.setItem("token", res.data.token);
          window.sessionStorage.setItem("userID", res.data.u_id);
          // this.$store.commit("SET_UID", res.data.u_id);
          // this.$store.commit("SET_TOKEN", res.data.token);
          // console.log(res.data.u_id, this.$store.state.user.u_id);
          // $(".login").hide();
          this.$message.success("登录成功");
          window.location.reload();
          this.showLogin = false;
        }
      });
    },
    async regBtn() {
      this.$refs["regForm"].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post("/reg", this.regForm);
          if (res.code !== 200) return this.$message.error(res.message);
          // 存储token
          // window.sessionStorage.setItem('token', res.data.token)
          this.$message.success("注册成功");
          this.$refs["regForm"].resetFields();
          document.querySelectorAll(".txtb input").forEach((item) => {
            item.classList.remove("focus");
          });
          this.signIn();
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
  background: transparent;
  box-shadow: none;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.login {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // width: 100%;
  // height: 100%;
  // background: rgba($color: #000000, $alpha: 0.4);
  // position: absolute;
  // left: 0;
  // top: 0;
  // transition: all 0.8;
  // ::v-deep .el-dialog__wrapper {
  //   z-index: 9999!important;
  // }
  // ::v-deep .v-modal {
  //   z-index: 99999!important;
  // }
}
#login-box {
  position: relative;
  margin: 0 auto;
  transition: all 0.8;
}
.close {
  position: absolute;
  right: 5%;
  top: 8%;
  font-size: 30px;
  color: #aaaaaa;
  cursor: pointer;
  z-index: 101;
}
h1 {
  font-weight: bold;
  margin: 0;
}
p {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 20px 0 30px;
}
span {
  font-size: 12px;
}
a {
  color: #333;
  font-size: 14px;
  text-decoration: none;
  margin: 15px 0;
}
.container {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  position: relative;
  overflow: hidden;
  width: 768px;
  max-width: 100%;
  min-height: 480px;
}
.form-container form {
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 0 50px;
  height: 100%;
  justify-content: center;
  text-align: center;
  .code {
    display: flex;
    align-items: center;
    .code-box {
      box-sizing: content-box;
    }
  }
}
.social-container {
  margin: 20px 0;
}
.social-container a {
  border: 1px solid #ddd;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
  height: 40px;
  width: 40px;
}
.social-container a:hover {
  background-color: #eee;
}
.txtb {
  border-bottom: 2px solid #adadad;
  position: relative;
  margin: 1em 0;
}
.txtb input {
  font-size: 15px;
  color: #333;
  border: none;
  width: 100%;
  outline: none;
  background: none;
  padding: 0 3px;
  height: 35px;
}
.txtb span::before {
  content: attr(data-placeholder);
  position: absolute;
  top: 50%;
  left: 5px;
  color: #adadad;
  transform: translateY(-50%);
  transition: 0.5s;
}
.txtb span::after {
  content: "";
  position: absolute;
  left: 0%;
  top: 100%;
  width: 0%;
  height: 2px;
  background-image: linear-gradient(120deg, #ff6191, #ffc39f);
  transition: 0.5s;
}
.focus + span::before {
  top: -5px;
}
.focus + span::after {
  width: 100%;
}
.el-button--default:hover {
  color: #fff !important;
}
button {
  border-radius: 20px;
  border: 1px solid #ff4b2b;
  background: #ff4b2b;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
  cursor: pointer;
}
button:active {
  transform: scale(0.95);
}
button:focus {
  outline: none;
}
button.ghost {
  background: transparent;
  border-color: #fff;
}
.form-container {
  position: absolute;
  top: 0;
  height: 100%;
  transition: all 0.6s ease-in-out;
}
.form-container button {
  background: linear-gradient(120deg, #ff6191, #ffc39f);
  border: none;
  background-size: 200%;
  color: #fff;
  transition: 0.5s;
}
.form-container button:hover {
  background-position: right;
}
.sign-in-container {
  left: 0;
  width: 50%;
  z-index: 2;
}
.sign-in-container form a {
  position: relative;
  left: 100px;
}
.sign-up-container {
  left: 0;
  width: 50%;
  z-index: 1;
  opacity: 0;
}
.sign-up-container button {
  // margin-top: 20px;
}
.overlay-container {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;
}
.overlay {
  background-image: linear-gradient(120deg, #ff6191, #ffc39f);
  color: #fff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateY(0);
  transition: transform 0.6s ease-in-out;
}
.overlay-panel {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 50%;
  text-align: center;
  transform: translateY(0);
  transition: transform 0.6s ease-in-out;
}
.overlay-right {
  right: 0;
  transform: translateY(0);
}
.overlay-left {
  transform: translateY(-20%);
}
.container.right-panel-active .sign-in-container {
  transform: translateY(100%);
}
.container.container.right-panel-active .overlay-container {
  transform: translateX(-100%);
}
.container.right-panel-active .sign-up-container {
  transform: translateX(100%);
  opacity: 1;
  z-index: 5;
}
.container.container.right-panel-active .overlay {
  transform: translateX(50%);
}
.container.container.right-panel-active .overlay-left {
  transform: translateY(0);
}
.container.container.right-panel-active .overlay-right {
  transform: translateY(20%);
}
</style>
